import { Typography } from "antd";
import { MainLogo } from "../../assets/images";

const Loadingtext = (id?:any) => {
    return (
        <div className="Loadingtext" id={id}>
            <MainLogo />
            {/* <div className="bottom">
                <Typography.Text className="loader-text">LOADING</Typography.Text>
            </div> */}
        </div>
    )
}
export default Loadingtext;